import { SalesOrderDeliveryType } from '../../../constants/sales-order-delivery-type/index.js';
/** The field a type's assignee lives in: the carrier for External, the driver for Internal, none for Pick Up. */
export function deliveryAssigneeRequiredField(deliveryTypeId) {
    if (deliveryTypeId === SalesOrderDeliveryType.EXTERNAL)
        return 'carrierId';
    if (deliveryTypeId === SalesOrderDeliveryType.INTERNAL)
        return 'deliveryDriverUserId';
    return null;
}
//# sourceMappingURL=delivery-assignee-required-field.js.map